// extracted by mini-css-extract-plugin
export default {"table":"StudySetsTable_table__aAnBj","addButton":"StudySetsTable_addButton__T4scF","searchField":"StudySetsTable_searchField__2eL38","emptyRow":"StudySetsTable_emptyRow__zR9jY"};